<template>
  <div class="player__social-items" ref="social">
    <ul>
      <li class="video-social_share__item">
        <span class="social-button--container">
          <span class="st_facebook_custom">
            <SVGLoader :src="'icon-facebook.svg'"></SVGLoader>
          </span>
        </span>
      </li>
      <li class="video-social_share__item">
        <span class="social-button--container">
          <span class="st_twitter_custom">
           <SVGLoader :src="'icon-twitter.svg'"></SVGLoader>
          </span>
        </span>
      </li>
      <li class="video-social_share__item">
        <span class="social-button--container">
          <span class="st_reddit_custom">
            <SVGLoader :src="'icon-reddit.svg'"></SVGLoader>
          </span>
        </span>
      </li>
      <li class="video-social_share__item">
        <span class="social-button--container">
          <span class="st_flipboard_custom">
            <SVGLoader :src="'icon-flipboard.svg'"></SVGLoader>
          </span>
        </span>
      </li>
      <li class="video-social_share__item">
        <span class="social-button--container">
          <button v-on:click="copyLinkToClipboard()">
            <SVGLoader :src="'icon-link.svg'"></SVGLoader>
          </button>
          <span class="social-tooltip tooltip__link">Link Copied</span>
        </span>
      </li>
      <li v-if="embedFlag" class="video-social_share__item">
        <span class="social-button--container">
          <button v-on:click="copyEmbedToClipboard()">
            <SVGLoader :src="'icon-embed.svg'"></SVGLoader>
          </button>
          <span class="social-tooltip tooltip__embed">Embed Code Copied</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
/* global stButtons */
import { mapGetters } from 'vuex'
import utils from '../assets/utils'

export default {
  name: 'SocialShare',
  components: { SVGLoader:() => import(/* webpackChunkName: "svgLoader", webpackPrefetch: true */ '../components/SVGLoader') },
  props: {
    current: Object
  },
  mounted () {
    this.checkID()
    this.updateSharethis(this.current)
  },
  methods: {
    /**
     * Updates share this buttons with current resource's metadata
     */
    updateSharethis (resource) {
      // Gets all sharethis buttons.
      var sharethisContainer = this.$refs.social.querySelectorAll('.social-button--container > span[class^="st_"]')
      // Loops through each sharethis item and updates them.
      var sharethisContainerLength = sharethisContainer.length

      var sharethisUrl = this.getResourcePageUrl(resource)
      for (var i = 0; i < sharethisContainerLength; i++) {
        sharethisContainer[i].removeAttribute('st_processed')
        sharethisContainer[i].setAttribute('st_url', sharethisUrl)
        sharethisContainer[i].setAttribute('st_title', resource.StoryHead)
        sharethisContainer[i].setAttribute('st_image', resource.ThumbnailURL)
        sharethisContainer[i].setAttribute('st_summary', resource.StoryHead)
      }
      if (typeof stButtons !== 'undefined') {
        stButtons.locateElements()
      }
    },
    /**
     * Get shareable link
     *
     * @returns {string}
     */
    getResourcePageUrl (resource) {
      return window.location.origin + resource.StoryPath + resource.StorySlug
    },
    /**
     * Sets some values
     */
    checkID () {
      this.brightcoveID = this.current.StoryId
      this.embedFlag = (typeof this.brightcoveID !== 'undefined' && this.brightcoveID && !this.$router.currentRoute.name.includes('live') && !this.$router.currentRoute.name.includes('video'))
    },
    /**
     * Copy link to clipboard
     */
    copyLinkToClipboard () {
      let toolTipLink = document.querySelector('.tooltip__link')
      if (!utils.isIOS()) {
        this.copyStringToClipboard(this.getResourcePageUrl(this.current))
      } else {
        this.copyStringToClipboardIOS(this.getResourcePageUrl(this.current))
      }
      this.addTooltip(toolTipLink)
    },
    /**
     * Copy an embed snippet to clipboard
     */
    copyEmbedToClipboard () {
      let Embed = JSON.stringify(this.current.EmbedUrl)
      let toolTipEmbed = document.querySelector('.tooltip__embed')
      let tempEmbed = '<iframe src='+ Embed +' style="border:none" width="620" height="349" allowfullscreen></iframe>'
      if (!utils.isIOS()) {
        this.copyStringToClipboard(tempEmbed)
      } else {
        this.copyStringToClipboardIOS(tempEmbed)
      }
      this.addTooltip(toolTipEmbed)
    },
    /**
     * Copy string to clipboard
     */
    copyStringToClipboard (copyValue) {
      let inp = document.createElement('input')
      document.querySelector('.player__wrapper--video').appendChild(inp)
      inp.value = copyValue
      inp.select()
      document.execCommand('copy', false)
      inp.remove()
    },
    /**
     * Copy string to clipboard for IOS
     */
    copyStringToClipboardIOS (copyValue) {
      let textArea = document.createElement('textArea')
      textArea.value = copyValue
      document.querySelector('.player__wrapper--video').appendChild(textArea)
      let range = document.createRange()
      range.selectNodeContents(textArea)
      let selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      textArea.setSelectionRange(0, 999999)
      document.execCommand('copy')
      document.querySelector('.player__wrapper--video').removeChild(textArea)
    },
    /**
     * Enables tooltip
     */
    addTooltip (tooltip) {
      tooltip.classList.remove('is-hidden')
      tooltip.classList.add('is-visible')
      this.removeTooltip(tooltip)
    },
    /**
     * Disables tooltip
     */
    removeTooltip (tooltip) {
      setTimeout(function (e) {
        tooltip.classList.add('is-hidden')
        tooltip.classList.remove('is-visible')
        setTimeout(function (e) {
          tooltip.classList.remove('is-hidden')
        }, 1200, this)
      }, 1200, this)
    }
  },
  watch: {
    current (val) {
      this.checkID()
      this.updateSharethis(val)
    }
  },
  data () {
    return {
      brightcoveID: this.current.StoryId,
      embedFlag: false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
  @import '../assets/scss/components/SocialShare.scss'
</style>
